import { Controller } from "@hotwired/stimulus";

export class SiteNavigationController extends Controller {
  static targets = ["navigationBar", "transparencyToggle"];
  static classes = ["nonTransparent"];

  connect() {
    console.log("Site Navigation Controller connected");
    let options = {
      rootMargin: "-92px 0px 0px 0px",
      threshold: 0,
    };

    let observer = new IntersectionObserver(
      ([entry]) => this.transparencyToggleObserver(entry),
      options
    );

    if (this.transparencyToggleTarget) {
      observer.observe(this.transparencyToggleTarget);
    }
  }

  /**
   * @param {IntersectionObserverEntry} entry
   */
  transparencyToggleObserver(entry) {
    if (entry.isIntersecting) {
      this.navigationBarTarget.classList.remove(this.nonTransparentClass);
    } else {
      console.log(entry.boundingClientRect);
      this.navigationBarTarget.classList.add(this.nonTransparentClass);
    }
  }

  /**
   * @param {import('@hotwired/stimulus').Application} application
   */
  static register(application) {
    application.register("site-navigation", this);
  }
}
